import { useMutation } from '@tanstack/react-query';

import { RevenuePlanApi } from '../revenuePlan.api';

export const useGetAllProductsCalculationsRevenue = () => {
  return useMutation({
    mutationFn: RevenuePlanApi.getAllProductsCalculations,
  });
};
